import React from 'react';
import { Link } from 'react-router-dom';

export const Button = ({ variant = 'primary', className = '', href, to, children, ...props }) => {
  const baseStyles = "inline-flex items-center justify-center font-medium transition-transform active:scale-95";

  let variantStyles = "";
  if (variant === 'primary') {
    variantStyles = "bg-gradient-to-r from-[#051A24] to-[#6D28D9] text-white rounded-full px-7 py-3 shadow-[0_4px_20px_rgba(109,40,217,0.25)] hover:shadow-[0_10px_36px_rgba(109,40,217,0.5)] transition-shadow";
  } else if (variant === 'secondary') {
    variantStyles = "bg-white text-[#051A24] rounded-full px-7 py-3 shadow-[0_0_0_0.5px_rgba(0,0,0,0.05),0_4px_30px_rgba(0,0,0,0.08)] hover:shadow-[0_4px_40px_rgba(109,40,217,0.18)] hover:text-[#4C1D95]";
  } else if (variant === 'tertiary') {
    variantStyles = "bg-white text-[#0D212C] rounded-full px-7 py-3 shadow-[0_1px_2px_0_rgba(5,26,36,0.1),0_4px_4px_0_rgba(5,26,36,0.09),0_9px_6px_0_rgba(5,26,36,0.05),0_17px_7px_0_rgba(5,26,36,0.01),0_26px_7px_0_rgba(5,26,36,0),inset_0_2px_8px_0_rgba(255,255,255,0.5)] hover:text-[#4C1D95]";
  } else if (variant === 'ghost') {
    variantStyles = "bg-transparent text-[#051A24] rounded-full px-5 py-2 hover:bg-[#7C3AED]/10 hover:text-[#4C1D95]";
  }

  const combinedStyles = `${baseStyles} ${variantStyles} ${className}`;

  if (to) {
    return (
      <Link to={to} className={combinedStyles} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={combinedStyles} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button className={combinedStyles} {...props}>
      {children}
    </button>
  );
};
